export default __webpack_public_path__ + "static/media/asbuilt.de5179e3.svg";